import AttributeFilters from '../attribute-filters'
import modelFiltersContainer from './modelFiltersContainer'

export default modelFiltersContainer(AttributeFilters)